import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const getTokenFromCookies = () => {
  const token = Cookies.get("jwt_token");
  return token;
};

export const timingsApiSlice = createApi({
  reducerPath: "timingsApi",
  baseQuery: fetchBaseQuery({ baseUrl: "http://localhost:3000/api/v1/org" }),
  tagTypes: ["Timings"],
  endpoints: (builder) => ({
    getTimings: builder.query({
      query: () => ({
        url: "/workingHours",
        method: "GET",
        headers: {
          Authorization: `Bearer ${getTokenFromCookies()}`,
        },
      }),
      transformResponse: (res) => {
        if (res && res.data && res.data.workingHours) {
          return res.data.workingHours;
        } else {
          return null;
        }
      },

      providesTags: ["Timings"],
    }),
    updateTimings: builder.mutation({
      query: (updatedWorkingHours) => ({
        url: "/editWorkingHours",
        method: "POST",
        body: {
          workingHours: updatedWorkingHours,
        },
        headers: {
          Authorization: `Bearer ${getTokenFromCookies()}`,
        },
      }),
      invalidatesTags: ["Timings"],
    }),
  }),
});

export const { useGetTimingsQuery, useUpdateTimingsMutation } = timingsApiSlice;
